import styled from '@emotion/styled';
import { Spacings } from '@styles/index';
import PropTypes from 'prop-types';

const ProgressBarWrapper = styled.div`
  display: flex;
  width: 100%;
  gap: ${Spacings.SPACING_1B};
`;

const ProgressBarStep = styled.div`
  background: ${({ $filled }) =>
    $filled ? 'var(--color-base-fill)' : 'var(--color-divider)'};
  border-radius: ${Spacings.SPACING_2B};
  height: ${Spacings.SPACING_1B};
  flex-grow: 1;
`;

const StepProgressBar = ({ steps, currentSteps }) => {
  const renderProgressBarStep = () => {
    const components = [];
    for (let i = 0; i < steps; i += 1) {
      components.push(
        <ProgressBarStep key={String(i)} $filled={i <= currentSteps - 1} />
      );
    }
    return components;
  };
  return <ProgressBarWrapper>{renderProgressBarStep()}</ProgressBarWrapper>;
};

export default StepProgressBar;

StepProgressBar.propTypes = {
  steps: PropTypes.number.isRequired,
  currentSteps: PropTypes.number.isRequired
};
